import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsCategoryEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsCategoryEntity
